export const FULL_DATE_LENGTH = 10
